import { render, staticRenderFns } from "./ListButtons.vue?vue&type=template&id=1f35668a&scoped=true&"
import script from "./ListButtons.vue?vue&type=script&lang=js&"
export * from "./ListButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35668a",
  null
  
)

export default component.exports